"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = exports.TEST_ID = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = require("react");
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var ArrowButton_1 = require("./ArrowButton");
var Image_1 = require("./Image");
// Range of unshaded images that are displayed in center
var VISIBLE_IMAGES_RANGE = [0, 2];
var MAX_VISIBLE_IMAGE_NUMBER = 3;
var DEFAULT_IMAGE_WIDTH = 460;
var DISPLAYED_ITEM_QUANTITY_ON_MEDIUM_RESOLUTION = 2;
var SINGLE_IMAGE_RESOLUTION = 530;
exports.TEST_ID = "carousel";
var Carousel = function (_a) {
    var heading = _a.heading, items = _a.items, _b = _a.gap, gap = _b === void 0 ? 20 : _b, _c = _a.dataTestId, dataTestId = _c === void 0 ? exports.TEST_ID : _c;
    var _d = react_1.useState(DEFAULT_IMAGE_WIDTH), imageWidth = _d[0], setImageWidth = _d[1];
    var _e = react_1.useState(0), offset = _e[0], setOffset = _e[1];
    var _f = react_1.useState(0), containerWidth = _f[0], setContainerWidth = _f[1];
    var _g = react_1.useState(VISIBLE_IMAGES_RANGE), visibleImages = _g[0], setVisibleImages = _g[1];
    var carousel = react_1.useRef(null);
    var imageBoxWidth = imageWidth + gap;
    var carouselWidth = imageBoxWidth * items.length;
    react_1.useLayoutEffect(function () {
        var handleResize = function () {
            var _a;
            var calculatedContainerWidth = ((_a = carousel.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
            setContainerWidth(calculatedContainerWidth);
            var imageStep;
            if (containerWidth < SINGLE_IMAGE_RESOLUTION) {
                // display one item
                setImageWidth(containerWidth);
                imageStep = 0;
            }
            else if (containerWidth < DEFAULT_IMAGE_WIDTH * MAX_VISIBLE_IMAGE_NUMBER + gap * 2) {
                // display two items when container's width less than 3 default images
                setImageWidth((containerWidth - gap) / DISPLAYED_ITEM_QUANTITY_ON_MEDIUM_RESOLUTION);
                imageStep = 1;
            }
            else {
                // display three items with shaded items
                setImageWidth(DEFAULT_IMAGE_WIDTH);
                imageStep = 2;
            }
            // scroll to first item on resize to avoid recalculations
            setOffset(0);
            setVisibleImages([0, imageStep]);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, [containerWidth, gap]);
    var changeImage = function (direction) {
        var directionSign = direction === "right" ? -1 : 1;
        var numberOfVisibleImages = Math.floor(containerWidth / imageBoxWidth);
        var restSpace = containerWidth - numberOfVisibleImages * imageBoxWidth;
        var nextImages;
        var nextOffset;
        if (direction === "left" && visibleImages[0] === 0) {
            // Previous before the first – scroll to the end
            nextImages = [items.length - (1 + numberOfVisibleImages), items.length - 1];
            nextOffset = -1 * ((items.length - numberOfVisibleImages) * imageBoxWidth - gap - restSpace);
        }
        else if (direction === "right" && visibleImages[1] === items.length - 1) {
            // Next to the last – scroll to beginning
            nextImages = [0, numberOfVisibleImages];
            nextOffset = 0;
        }
        else {
            nextImages = [visibleImages[0] - directionSign, visibleImages[1] - directionSign];
            nextOffset = offset + directionSign * imageBoxWidth;
        }
        setVisibleImages(nextImages);
        setOffset(nextOffset);
    };
    return (theme_ui_1.jsx(theme_ui_1.Box, { "data-testid": dataTestId, sx: {
            overflow: "hidden",
        } },
        theme_ui_1.jsx(theme_ui_1.Grid, { as: "section", ref: carousel, sx: {
                maxWidth: "1420px",
                margin: "0 auto",
                alignItems: "baseline",
                gridTemplateRows: "auto 230px 48px",
                gridTemplateColumns: "1fr 60px",
                gridTemplateAreas: "\"title arrows\"\n                                        \"slider slider\"",
                // not using breakpoints to avoid code duplication
                "@media screen and (max-width: 576px)": {
                    gridTemplateAreas: "\"title title\"\n                                            \"slider slider\"\n                                            \"none arrows\"",
                },
            } },
            theme_ui_1.jsx(__1.Heading, { sx: {
                    gridArea: "title",
                    textAlign: "left",
                    alignSelf: "center",
                    mt: 0,
                }, as: "h3", variant: "text.h3" }, heading),
            (containerWidth < carouselWidth - gap) && theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignSelf: "center",
                    gridArea: "arrows",
                    height: "42px",
                    width: "60px",
                } },
                theme_ui_1.jsx(ArrowButton_1.ArrowButton, { direction: "left", onClick: function () { return changeImage("left"); } }),
                theme_ui_1.jsx(ArrowButton_1.ArrowButton, { direction: "right", onClick: function () { return changeImage("right"); } })),
            theme_ui_1.jsx(theme_ui_1.Box, { sx: {
                    gridArea: "slider",
                    width: "100%",
                    gridColumnStart: "1",
                    gridColumnEnd: "3",
                } },
                theme_ui_1.jsx(theme_ui_1.Flex, { as: "ul", sx: {
                        padding: 0,
                        width: "fit-content",
                        alignItems: "flex-start",
                        transition: "400ms ease-in-out",
                        transform: "translate(" + offset + "px)",
                    } }, items.map(function (_a, index) {
                    var text = _a.text, imageUri = _a.imageUri;
                    return (theme_ui_1.jsx(Image_1.Image, { key: text + index, text: text, imageUri: imageUri, width: imageWidth, margin: gap, isShaded: index < visibleImages[0] || index > visibleImages[1] }));
                }))))));
};
exports.Carousel = Carousel;
